module.exports = __webpack_public_path__ + "assets/a0c513a44214df23f57c2b9f69f6b3ae.svg";